import { axiosRequest } from '../../utils/Requests.js';

export default {
    data() {
        return {
            loading: true,
            imobiliaria: {},
            rota: this.$router.currentRoute.name,
            urlMapaEstatico: null,
            urlPlace: null,
        }
    },

    computed: {
      somenteAluguel() { return this.imobiliaria.aluguel && !this.imobiliaria.venda },
      somenteVenda() { return this.imobiliaria.venda && !this.imobiliaria.aluguel },
      ambos() { return this.imobiliaria.venda && this.imobiliaria.aluguel },

      numeroWhatsApp() {
        if(this.somenteAluguel) { return this.imobiliaria.whatsappAluguel; }
        if(this.somenteVenda) { return this.imobiliaria.whatsappVenda; }
        if(this.ambos) { return this.imobiliaria.whatsappAluguel; }
  
        return undefined;
      },
      numeroWhatsAppSemFormatacao() {
        if(this.somenteAluguel) { return this.imobiliaria.whatsappAluguelSemFormatacao; }
        if(this.somenteVenda) { return this.imobiliaria.whatsappVendaSemFormatacao; }
        if(this.ambos) { return this.imobiliaria.whatsappAluguelSemFormatacao; }
        
        return undefined;
      },

      isMapaVisible() {
        return this.urlMapaEstatico != null;
      },
    },

    beforeRouteEnter(to, from, next) {
      axiosRequest.get("/index")
        .then((resultado) => {
          next(vm => vm.setData(resultado.data))
        }).catch((erro) => {
          console.log(erro);
        });
    },
    
    methods: {
      setData(imobiliaria) {
        this.imobiliaria = imobiliaria
        this.setUrlMapaEstatico(imobiliaria.urlMapaEstatico)
        this.setUrlPlace(imobiliaria.urlPlace)
        this.loading = false
      },

      setUrlMapaEstatico(url) {
        this.urlMapaEstatico = url;
      },

      setUrlPlace(url) {
        this.urlPlace = url;
      },

      alterarRota(nome) {
          this.rota = nome
      },

      irParaPagina(nome) {
          this.$router.push({ name: nome })
          this.rota = nome
      }
    },

    watch: {
      '$route'(to, from) {
          this.rota = this.$router.currentRoute.name
      }
    }
}
